import { render, staticRenderFns } from "./CRMOptionButton.vue?vue&type=template&id=f1c710f0&scoped=true&"
import script from "./CRMOptionButton.vue?vue&type=script&lang=js&"
export * from "./CRMOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./CRMOptionButton.vue?vue&type=style&index=0&id=f1c710f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c710f0",
  null
  
)

export default component.exports